export const REDIRECT = {
  pwa: "https://em-pwa.moxey.ai",
  web: "https://em-client.moxey.ai",
};
